import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { productCategories } from '../mock';
import Seo from '../components/Seo';

const tabs = [
  { key: 'mat', label: 'Mattress' },
  { key: 'bed', label: 'Beds' },
  { key: 'war', label: 'Wardrobe & Storage' },
  { key: 'desk', label: 'Desk & Chairs' },
  { key: 'lou', label: 'Lounge & Sofa' },
  { key: 'tab', label: 'Tables & Chairs' },
  { key: 'tv', label: 'TV Unit & Tables' },
  { key: 'home', label: 'Homewares' },
];

const Furniture = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('mat');

  useEffect(() => {
    const hash = location.hash.replace('#', '');
    if (hash && tabs.find((t) => t.key === hash)) {
      setActiveTab(hash);
    }
  }, [location.hash]);

  const products = productCategories[activeTab]?.products || [];

  return (
    <div className="bg-white min-h-screen">
      <Seo
        title="Furniture Collection | Beds, Mattresses, Sofas & More — Satis Furniture Sydney"
        description="Browse our full furniture range at factory-direct prices: mattresses, beds, wardrobes, desks, sofas, dining sets, TV units and homewares. Visit our Campsie outlet or call (02) 97872567."
        path="/furniture"
      />
      <Header />

      {/* Page Hero */}
      <section className="relative w-full h-[400px] md:h-[450px] overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1567538096630-e0c55bd6374c?w=1920&q=80')",
          }}
        />
        <div className="absolute inset-0 bg-black/55" />
        <div className="relative z-10 h-full flex flex-col items-center justify-center px-6 text-center pt-20">
          <div className="inline-block border-2 border-white/70 rounded-full px-5 py-2 mb-6">
            <span className="text-white text-xs md:text-sm tracking-wide">
              Free home delivery in Sydney within 10kms of store
            </span>
          </div>
          <h1 className="text-white text-5xl md:text-7xl lg:text-[88px] font-medium mb-8 tracking-tight font-display-serif leading-[1.05]">Furniture</h1>
          <a
            href="tel:+61411418088"
            className="inline-block bg-white text-black px-8 py-3 rounded-full text-sm font-medium hover:bg-gray-100 transition-colors btn-transition"
          >
            Call Now
          </a>
        </div>
      </section>

      {/* Tabs */}
      <section className="py-10 md:py-14 px-4 md:px-10 bg-white">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex gap-2 md:gap-3 overflow-x-auto no-scrollbar pb-3 mb-10 border-b border-gray-200">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={`flex-shrink-0 px-5 py-2.5 rounded-full text-sm font-medium whitespace-nowrap transition-all btn-transition ${
                  activeTab === tab.key
                    ? 'bg-black text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {/* Section heading */}
          <div className="mb-10">
            <h2 className="text-2xl md:text-4xl font-bold text-black">
              {productCategories[activeTab]?.title}
            </h2>
            <p className="text-gray-500 text-sm mt-2">
              {products.length} products available
            </p>
          </div>

          {/* Products grid */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 md:gap-6">
            {products.map((p, idx) => (
              <div
                key={`${activeTab}-${idx}`}
                className="group cursor-pointer card-transition"
              >
                <div className="aspect-square bg-gray-50 rounded-2xl overflow-hidden mb-3 relative">
                  <img
                    src={p.image}
                    alt={p.name}
                    className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/5 transition-colors duration-300" />
                </div>
                <h3 className="text-sm md:text-base font-semibold text-black px-1">
                  {p.name}
                </h3>
              </div>
            ))}
          </div>

          {/* View More */}
          <div className="text-center mt-14">
            <a
              href="tel:+61411418088"
              className="inline-block bg-black text-white px-10 py-3 rounded-full text-sm font-medium hover:bg-gray-800 transition-colors btn-transition"
            >
              Enquire Now
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Furniture;
